import { createContext, useContext } from 'react'

import { theme as defaultTheme } from '@tribeplatform/design-system/themes/default'
import type {
  ThemeColors,
  AppearanceStyle,
  Theme,
  Typography,
} from '@tribeplatform/design-system/types'
import { typography as defaultTypography } from '@tribeplatform/design-system/typography/system'

import { DEFAULT_STYLE, DEFAULT_THEME_ASSETS } from './constants.js'
import { ThemeAssets } from './types.js'

export type ThemeProps = {
  theme: Theme
  currentThemeColors: ThemeColors
  style: AppearanceStyle
  assets: ThemeAssets
  typography: Typography
}

export const ThemeContext = createContext<ThemeProps>({
  theme: defaultTheme,
  currentThemeColors: defaultTheme.light1,
  style: DEFAULT_STYLE,
  assets: DEFAULT_THEME_ASSETS,
  typography: defaultTypography,
})

export const useThemeContext = () => {
  const context = useContext(ThemeContext)
  if (context === undefined) {
    throw new Error('useThemeContext must be used within a ThemeProvider')
  }
  return context
}
